import type { IconName } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

import styles from './DataTable.module.css';

type Props = {
  icon: IconName;
  children: string;
};

export function DataTableActionContent({ icon, children }: Props) {
  return (
    <span className={styles.actionContent}>
      <Icon name={icon} size="small" />
      {children}
    </span>
  );
}
